import React from 'react';

const ContactUs = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6 4xl:px-32 4xl:py-20">
      <div className="max-w-7xl 4xl:max-w-[1700px] mx-auto bg-white rounded-2xl shadow-lg overflow-hidden grid grid-cols-1 md:grid-cols-2 4xl:gap-20">

        {/* Contact Form */}
        <div className="p-8 4xl:p-12">
          <h2 className="text-3xl 4xl:text-5xl font-bold text-gray-800 mb-6">Contact Us</h2>
          <form className="space-y-4 text-base 4xl:text-lg">
            <div>
              <label className="block text-gray-700 mb-1">Full Name</label>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Email</label>
              <input
                type="email"
                placeholder="your@email.com"
                className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Phone Number</label>
              <input
                type="text"
                placeholder="+91 XXXXX XXXXX"
                className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1">Message</label>
              <textarea
                rows="4"
                placeholder="Your message..."
                className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white font-semibold py-2 rounded-xl hover:bg-blue-700 transition duration-300"
              style={{ backgroundColor: 'deepskyblue' }}
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Company Info & Map */}
        <div className="bg-blue-50 p-8 4xl:p-12 flex flex-col justify-between">
          <div>
            <h3 className="text-2xl 4xl:text-4xl font-semibold mb-4" style={{ color: 'deepskyblue' }}>
              LABH Industries
            </h3>
            <p className="text-gray-700 mb-4 text-sm 4xl:text-base">
              In response to the growing demands for a ‘All Solutions Under One Roof’ beyond EPC, Labh Industries is enhancing its competitiveness by combining our excellent project.
            </p>
            <div className="text-gray-600 space-y-2 text-sm 4xl:text-base">
              <p><strong>Address:</strong> Plot 221, Navi Jambuvai, Near Ajwa Canal - Nimeta Village, Taluka - Waghodia, Vadodara – 391760</p>
              <p><strong>Email:</strong> <a href="mailto:amp@labhind.com">amp@labhind.com</a></p>
              <p><strong>Phone:</strong> <a href="tel:+919909501696">+91 99095 01696</a></p>
              <p><strong>Hours:</strong> Mon - Sat, 9:00 AM - 6:00 PM</p>
            </div>
          </div>
          <div className="mt-6">
            <iframe
              className="w-full h-48 4xl:h-64 rounded-xl"
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14889.136980147636!2d72.864696!3d21.101231!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0514b54c22ffd%3A0xb386c0b16da14fd8!2sSachin%20GIDC!5e0!3m2!1sen!2sin!4v1744782974978!5m2!1sen!2sin"
              frameBorder="0"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
